import APIKit from "../Allapis/Apikit/apikit";

 export const getIntroducers = async(id)=>{
    const endpoint = id ? `/introducers/${id}` : `/introducers`;
    const res = await APIKit.get(endpoint)
    return res.data
 }
 export const createIntroducers = async(values)=>{
    const res = await APIKit.post(`/introducers`,values)
    return res.data
  }

  export const updateIntroducers = async (id, values) => {
    const res = await APIKit.put(`/introducers/${id}`, values);
    return res.data;
  };

  export const deleteIntroducers = async (del_id) => {
    const res = await APIKit.delete(`/introducers/${del_id}`);
    return res.data;
  };
